import { type TokenData } from 'data/types/token-data';
import { useTokenData as useAuthStoreTokenData } from 'data/stores/auth-store';

/**
 * For backwards compatibility, use the hook from the auth store
 */
export const useTokenData = (): TokenData | undefined => useAuthStoreTokenData();
